import styled from "styled-components"

export const Container = styled.main`
  
  height: 100vh;
  width: 100%;
  padding: 0;
  margin: 0;

`